import { Button, Col, Form, Input, Row, Space, Modal } from "antd";
import Password from "antd/lib/input/Password";
import "crypto-js/lib-typedarrays";
import Amplify, { API, Auth } from "aws-amplify";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useAppSelector } from "../../../app/hooks";
import {
  login,
  PlayerMode,
  selectPlayer,
  setDisplayName,
  setPlayerMode,
  updateAccount,
} from "../../../features/player/playerSlice";
import { useDispatch } from "react-redux";
import { checkAccountState, getKioskData } from "../../../graphql/queries";
import { GRAPHQL_AUTH_MODE, GraphQLResult } from "@aws-amplify/api-graphql";
import { CheckAccountStateQuery, GetKioskDataQuery } from "../../../API";
import {
  selectTheme,
  ThemeMode,
  themeSlice,
} from "../../../features/theme/themeSlice";

type Props = {
  onLoginSuccess?: () => void;
  onClose?: () => void;
  visible: boolean;
};

type CognitoException = {
  name: string;
  code: any;
};

const modalLoginError = (message: string) => {
  Modal.error({
    content: <p>{message}</p>,
  });
};

const LoginFormPopup = ({ onLoginSuccess, onClose, visible }: Props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [formInError, setFormInError] = useState(false);
  const [loginButtonDisabled, setLoginButtonDisabled] = useState(false);
  const player = useAppSelector(selectPlayer);
  const theme = useAppSelector(selectTheme);
  const dispatch = useDispatch();

  //useEffect(() => {}, [username, password]);

  useEffect(() => {
    setUsername("");
    setPassword("");
  }, []);

  // const loginFn = async () => {
  // 	try {
  // 		if (!formInError && username !== '' && password !== '') {
  // 			const user = await Auth.signIn({ username: username, password: password });
  // 			onLoginSuccess && onLoginSuccess();
  // 			setUsername('');
  // 			setPassword('');
  // 		}
  // 	} catch (e) {
  // 		const error = e as CognitoException;
  // 		if (error.name === 'UserNotFoundException') modalLoginError('User not found exception');
  // 		else modalLoginError(error.name);
  // 		console.log('error', e);
  // 	}
  // };
  const loginFn = async () => {
    setLoginButtonDisabled(true);
    try {
      if (!formInError && username !== "" && password !== "") {
        const user = await Auth.signIn({
          username: username,
          password: password,
        });
        console.log(user);
        const { email } = user.attributes;
        const groups =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        if (theme.mode == ThemeMode.KIOSK && !(groups.indexOf("kiosks") > -1)) {
          const g = groups.join(" - ");
          Modal.error({
            title: "Errore login",
            content: <p>{g} non autorizzati/o!</p>,
          });
          Auth.signOut();
          return;
        }

        if (
          theme.mode === ThemeMode.DEFAULT &&
          !(groups.indexOf("Players") > -1)
        ) {
          const g = groups.join(" - ");
          Modal.error({
            title: "Errore login",
            content: <p>{g} non autorizzati/o!</p>,
          });
          Auth.signOut();
          return;
        }

        dispatch(
          login({ username: user.username, email: email, groups: groups })
        );
        if (groups.indexOf("kiosks") > -1) {
        //  dispatch(setPlayerMode(PlayerMode.KIOSK));
        }
        onLoginSuccess();
        (async () => {
          const result: GraphQLResult<CheckAccountStateQuery> =
            (await API.graphql({
              query: checkAccountState,
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              variables: {
                username: user.username,
              },
            })) as GraphQLResult<CheckAccountStateQuery>;

          dispatch(updateAccount(result.data.checkAccountState));
          if (groups.indexOf("kiosks") > -1) {
            (async () => {
              const result: GraphQLResult<GetKioskDataQuery> =
                (await API.graphql({
                  query: getKioskData,
                  authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
                  variables: {},
                })) as GraphQLResult<GetKioskDataQuery>;
              dispatch(setDisplayName(result.data.getKioskData.name));
            })();
          }
        })();
      }
    } catch (e) {
      setLoginButtonDisabled(false);
      const error = e as CognitoException;
      if (error.name === "UserNotFoundException")
        modalLoginError("User not found exception");
      else modalLoginError(error.name);
      console.log("error", e);
    }
  };

  return (
    <div className={`login-form-popup-container ${visible ? "visible" : ""}`}>
      <div className={`login-form-popup ${visible ? "login-visible" : ""}`}>
        {player.mode !== PlayerMode.KIOSK && (
          <div
            className="orange close-icon pointer"
            onClick={() => {
              onClose && onClose();
            }}
          >
            <FontAwesomeIcon icon={faClose} />
          </div>
        )}
        <div className="login-form-content">
          <div className="input-control">
            <Input
              className={`username-input ${
                formInError ? "input-error input-login-required" : ""
              }`}
              name="username"
              placeholder="username"
              value={username}
              onChange={(evt) => {
                setFormInError(false);
                setUsername(evt.target.value);
              }}
            />
            {formInError && (
              <div className="login-required-field-error">
                <FormattedMessage id="login.required.field" />
              </div>
            )}
          </div>

          <div className="input-control">
            <Password
              className={`password-input ${
                formInError ? "input-error input-login-required" : ""
              }`}
              name="password"
              placeholder="password"
              value={password}
              onChange={(evt) => {
                setFormInError(false);
                setPassword(evt.target.value);
              }}
            />
            <div
              className="d-forgot-password"
              style={{ textAlign: "right", color: "white" }}
            >
              <FormattedMessage id="login.forgot.password" />
            </div>
            {formInError && (
              <div className="login-required-field-error">
                <FormattedMessage id="login.required.field" />
              </div>
            )}
          </div>

          <div className="login-buttons d-flex f-column">
            <div>
              <Button
                className="login-button with-border login-submit"
                htmlType="submit"
                onClick={(e) => {
                  if (username === "" || password === "") {
                    setFormInError(true);
                    return;
                  }
                  loginFn();
                }}
                type="primary"
                disabled={loginButtonDisabled}
              >
                Login
              </Button>
            </div>

            <div>
              {theme.mode !== ThemeMode.KIOSK && (
                <Link
                  to="/register"
                  className="ant-btn ant-btn-default register-btn with-border "
                >
                  <FormattedMessage id="register" />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginFormPopup;
